import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid } from "@material-ui/core";
import { LabReportHeader } from "./components/LabReportHeader";
import { ElementTable } from "./components/tables/elements-table/ElementTable";

export const LabReport = () => {
	const {
		state: { heatLabData },
	} = useHeatReportContext();
	return (
		<>
			<Grid item xs={12} container spacing={1} justifyContent="center">
				<Grid item xs={12} container spacing={1}>
					<LabReportHeader />
				</Grid>
				<Grid item xs={12} container>
					<Grid item xs={12}>
						<ElementTable key={heatLabData?.HeatId} />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};
